import { APPOINTMENTS_STATUS } from '../../../../../services/appointments';

export const isEditable = status => {
  return ![APPOINTMENTS_STATUS.COMPLETED, APPOINTMENTS_STATUS.CANCELED, APPOINTMENTS_STATUS.NO_SHOW].includes(
    status.code,
  );
};
